// Home, signed out: an example conversation instead of the lone logo (Home.dc.html, design changelog
// «signed-out hero shows an answer, not a logo»). The numbers are illustrative and labelled as an example.
import { BrandMark } from "./BrandMark";
import { t } from "../i18n";
import { SourceIcon } from "./brand-icons";

const ROWS = [
  { id: "meta", name: "Meta Ads", spend: "€2,140", installs: "1,312", up: true },
  { id: "google_ads", name: "Google Ads", spend: "€860", installs: "402", up: false },
  { id: "revenuecat", name: "RevenueCat", spend: "-", installs: "731 trials", up: false },
] as const;

export function ExampleAnswer() {
  return (
    <figure className="card elev-md example-answer" aria-label={t("home.example.label")} data-testid="example-answer">
      <div className="example-q">{t("home.example.question")}</div>
      <div className="example-a">
        <BrandMark size={22} />
        <div className="example-body">
          <p>
            {t("home.example.answer")} <span className="example-strong">€4.10</span>.
          </p>
          <div className="example-table" role="table">
            {/* Header cells sit in a row of their own: a table owns rows only (BL-156). */}
            <span style={{ display: "contents" }} role="row">
              <span className="example-th" role="columnheader">{t("home.example.colSource")}</span>
              <span className="example-th num" role="columnheader">{t("home.example.colSpend")}</span>
              <span className="example-th num" role="columnheader">{t("home.example.colInstalls")}</span>
            </span>
            {ROWS.map((r) => (
              <span key={r.id} style={{ display: "contents" }} role="row">
                <span className="example-src" role="cell">
                  <SourceIcon id={r.id} size={14} />
                  {r.name}
                </span>
                <span className={r.spend === "-" ? "num muted" : "num"} role="cell">{r.spend}</span>
                <span className="num" role="cell">
                  {r.installs}
                  {r.up && <span className="example-up"> ↑</span>}
                </span>
              </span>
            ))}
          </div>
          <span className="example-foot">{t("home.example.foot")}</span>
        </div>
      </div>
    </figure>
  );
}
